import React, { createContext, useContext, useState } from 'react';

export interface CopywritingInstruction {
  id: string;
  set: string;
  copywriting_instructions: string;
  copywriting_style: string;
  created_at: string;
  updated_at: string;
}

interface CopywritingInstructionsContextType {
  isOpen: boolean;
  editingInstruction: CopywritingInstruction | null;
  openAddInstructions: () => void;
  openEditInstructions: (instruction: CopywritingInstruction) => void;
  closeInstructionsDialog: () => void;
}

const CopywritingInstructionsContext = createContext<CopywritingInstructionsContextType | undefined>(undefined);

export const CopywritingInstructionsProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [editingInstruction, setEditingInstruction] = useState<CopywritingInstruction | null>(null);

  const openAddInstructions = () => {
    setEditingInstruction(null);
    setIsOpen(true);
  };

  const openEditInstructions = (instruction: CopywritingInstruction) => {
    setEditingInstruction(instruction);
    setIsOpen(true);
  };

  const closeInstructionsDialog = () => {
    setIsOpen(false);
    setEditingInstruction(null);
  };

  return (
    <CopywritingInstructionsContext.Provider 
      value={{ 
        isOpen, 
        editingInstruction, 
        openAddInstructions, 
        openEditInstructions, 
        closeInstructionsDialog 
      }}
    >
      {children}
    </CopywritingInstructionsContext.Provider>
  );
};

export const useCopywritingInstructions = () => {
  const context = useContext(CopywritingInstructionsContext);
  if (context === undefined) {
    throw new Error('useCopywritingInstructions must be used within a CopywritingInstructionsProvider');
  }
  return context;
};

